import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "npbc_admin_token";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Strip empty-string optional fields
function cleanEmpty(value) {
  if (Array.isArray(value)) return value.map(cleanEmpty);
  if (value && typeof value === "object") {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      if (typeof v === "string" && v.trim() === "") continue;
      out[k] = cleanEmpty(v);
    }
    return out;
  }
  return value;
}

api.interceptors.request.use((config) => {
  // Attach bearer token if we have one
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
  }
  if (config.data && typeof config.data === "object") {
    config.data = cleanEmpty(config.data);
  }
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}
